import React from 'react';
import ShowSwitch from './ShowSwitch';
import { TableItemActionsNew, Icons } from 'components';
const columns = (showServiceSet, showDetailsWebService, edit, actionsList) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    cellStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه',
    field: 'id',
    align: 'center',
  },
  {
    title: 'نام سرویس',
    field: 'name',
  },
  {
    title: 'نسخه',
    field: 'serviceVersion',
    align: 'center',
    filtering: false,
  },
  {
    title: 'ارائه دهنده',
    field: 'providerBusiness',
    align: 'center',
    filtering: false,
  },
  {
    title: 'روش محاسبه',
    field: 'calculationMethod',
    align: 'center',
    render: (rowData) =>
      rowData.calculationMethod === 'ثابت' ? (
        <span>
          {rowData.calculationMethod === 'ثابت' ? `${rowData.price}﷼` : rowData.calculationMethod}
          <small />
        </span>
      ) : (
        rowData.calculationMethod
      ),
    filtering: false,
  },
  {
    title: 'وضعیت',
    field: 'enable',
    align: 'center',
    render: (rowData) => <ShowSwitch rowData={rowData} />,
    defaultFilter: 'false',
    filterValue: 'false',
  },
  ...((actionsList['editMyWebServiceListBtn'] ||
    actionsList['detailMyWebServiceListBtn'] || actionsList['subMyWebServiceListBtn']) ? [{
      title: 'عملیات',
      field: 'operationSmall',
      filtering: false,
      sorting: false,
      align: 'right',
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
      render: (rowData) => (
        <TableItemActionsNew
          iconButton
          startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
          title=""
          otherMenus={[
            {
              title: 'مجموعه سرویس',
              isShow: !!actionsList['subMyWebServiceListBtn'],
              onClick: () => showServiceSet(rowData),
            },
            {
              title: 'جزییات',
              isShow: !!actionsList['detailMyWebServiceListBtn'],
              onClick: () => showDetailsWebService(rowData),
            },
            {
              title: 'ویرایش',
              isShow: !!actionsList['editMyWebServiceListBtn'],
              onClick: () => edit(rowData),
            },

          ]}
        />
      ),
    }] : []),
];

const colMap = {
  name: 'text',
  id: 'id',
  enable: 'showDisable',
};

export { columns, colMap };
